// src/components/Clientes.jsx
import React, { forwardRef } from "react";

const clientesData = [
  { src: "/assets/Logos Alta calidad/casa arab.jpg" },
  { src: "/assets/Logos Alta calidad/flexxus rojo y blanco.png" },
  { src: "/assets/Logos Alta calidad/G BUNKER.png" },
  { src: "/assets/Logos Alta calidad/G-TEC logo 400px fondo transparente (1).png" },
  { src: "/assets/Logos Alta calidad/Logo Getlead.png" },
  { src: "/assets/Logos Alta calidad/Logo Sveltia - blancoverde.png" },
  { src: "/assets/Logos Alta calidad/logo-pferd-nuevo-blanco.png" },
  { src: "/assets/Logos Alta calidad/marca moldear.jpg" },
  { src: "/assets/Logos Alta calidad/NEVERLAND.png" },
  { src: "/assets/Clientes/lopez-atelier.png", scale: 0.8 },
  { src: "/assets/Clientes/telgomol.png" },
  { src: "/assets/Clientes/imagen-3.jpeg" },
  { src: "/assets/Clientes/agrober.jpg" },
];

const Clientes = forwardRef((props, ref) => {
  const logosParaAnimacion = [...clientesData, ...clientesData];

  return (
    <section
      ref={ref}
      className="py-32 px-6 bg-neutral text-primary relative overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 opacity-20"></div>

      <div className="max-w-6xl mx-auto text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">Clientes</h2>
        <p className="text-lg" style={{ color: "#120B3E" }}>
          Algunas de las empresas que confían en nosotros.
        </p>
      </div>

      {/* Gradientes laterales */}
      <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-neutral/100 to-neutral/0 pointer-events-none z-10"></div>
      <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-neutral/100 to-neutral/0 pointer-events-none z-10"></div>

      {/* Carrusel */}
      <div className="relative w-full overflow-hidden">
        <div className="flex animate-scroll">
          {logosParaAnimacion.map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 flex justify-center items-center p-4"
              style={{
                width: "clamp(8rem, 10vw, 10rem)",
                height: "clamp(8rem, 10vw, 10rem)",
              }}
            >
              <img
                src={logo.src}
                alt={`Cliente ${index + 1}`}
                className="object-contain"
                style={{ transform: `scale(${logo.scale ?? 1.2})` }}
              />
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          display: flex;
          gap: 2rem;
          width: max-content;
          animation: scroll 60s linear infinite;
        }
      `}</style>
    </section>
  );
});

export default Clientes;
